import { render, staticRenderFns } from "./ConfirmationVotingModal.vue?vue&type=template&id=67db2a38&scoped=true&"
import script from "./ConfirmationVotingModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmationVotingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db2a38",
  null
  
)

export default component.exports